var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"block",class:_vm.isSpaceByBorder && 'border',style:([
    !!_vm.color && {
      backgroundColor: _vm.color
    },
    !!_vm.specialWidth && { width: (_vm.specialWidth + "%") }
  ])},'span',_vm.dataAttrs,false),[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }